
import React, {Component} from 'react'
import {Button, Modal, ModalHeader, ModalBody} from "reactstrap";
import Floor from "../../components/floor/Floor";
import ErrorComponent from "../../components/error/ErrorComponent";
import LoadingComponent from "../../components/loading/LoadingComponent";
import Select from 'react-select';
import { LuRefreshCw } from "react-icons/lu";

const logger = require("../../utils/logger/logger");
const translator = require("../../utils/translator/translator");
const stringUtil = require("../../utils/string/stringUtil");
const salesLoader = require("../../utils/domain/sales/salesLoader");
const constants = require("../../utils/domain/constants");
var stateManager = require('../../utils/state/stateManager.js');
var staffUtility = require('../../utils/domain/staff/staffUtility');
var storefrontUtility = require('../../utils/domain/storefrontUtility');
var saleContextUtil = require('../Order/utils/saleContextUtil');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');
var saleInitializer = require('../../utils/domain/sales/saleInitializer');

class TableSelectionView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.isLoadingSales = false;
        this.state.unmounted = false;
        this.state.criticalError = null;
        this.state.validationError = null;

        this.state.context = {};
        if (this.props.sale == null)
        {
            this.state.context = {};
            this.state.context.sale = null;
            this.state.context.noOfGuests = 1;
            this.state.context.server = staffUtility.getStaffCompleteName(staffUtility.getLoginStaffData().staff);
            this.state.context.tableNumber = null;
            this.state.context.linkedTables = [];
        }
        else
        {
            this.state.context.sale = this.props.sale;
            this.state.context.noOfGuests = this.props.sale.noOfGuests ?? 1;
            this.state.context.server = this.props.sale.server;
            this.state.context.tableNumber = this.props.sale.tableNumber;
            this.state.context.linkedTables = this.props.sale.linkedTables ?? [];
        }

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onStencilClick = this.onStencilClick.bind(this);
        this.isStencilEnabled = this.isStencilEnabled.bind(this);
        this.isStencilSelected = this.isStencilSelected.bind(this);
        this.openNewSale = this.openNewSale.bind(this);
        this.updateExistingSale = this.updateExistingSale.bind(this);
        
    }

    handleCancel()
    {
        this.state.unmounted = true;

        if (this.props.onCancel != null)
        {
            this.props.onCancel();
        }
        else
        {
            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
        }
    }

    handleOk()
    {
        let storefront = storefrontUtility.getCurrentStorefront();
        if (this.state.context.sale != null)
            storefront = storefrontUtility.getStorefrontById(this.state.context.sale.storefrontId);

        if(storefront.operatingConfiguration.dineInRequiresOrderReference == constants.triStateFlag.always &&
            stringUtil.isStringNullOrEmpty(this.state.context.tableNumber)) 
        {
            this.state.validationError = translator.getLabel("table_number_is_not_set");
            this.setState({});
            return;
        }

        if (this.state.context.sale == null)
        {
            this.openNewSale();
        }
        else
        {
            this.updateExistingSale();
        }
    }

    render()
    {
        if (this.state.isLoadingSales)
        {
            this.loadSales();
        }

        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} style={{minWidth:'95vw'}}>
                <ModalHeader
                    close={
                        <div className='d-flex flex-row align-items-center gap-3'>
                            {this.renderTableSelectionToolbar()}
                        <div className='d-flex'>
                            <Button className='btn-action' disabled={this.isDisabled()} style={{minWidth:'5vw', marginRight:'40px'}}
                                onClick={()=>
                                {
                                    logger.usage("TableSelection.Refresh", "Staff clicked refresh button to refresh sales");
                                    this.state.isLoadingSales = true;
                                    this.setState({});
                                }}>
                            <LuRefreshCw/>
                            </Button>
                                <Button className="btn-cancel" onClick={this.handleCancel}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                                <Button className="btn-ok" disabled={this.isDisabled()} onClick={this.handleOk}>{translator.getLabel("done")}</Button>
                        </div>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("table_selection")}</span>
                </ModalHeader>
                <ModalBody className='p-0'>
                    <div className='d-flex flex-column'>
                        
                        <div style={{height:'80vh'}}>
                            {this.renderFloor()}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    renderTableSelectionToolbar()
    {
        return <div className='w-100 d-flex justify-content-center'>
                    <div>
                        {this.renderNoOfCoversComponent()}
                    </div>
                    <div>
                        {this.renderServerComponent()}
                    </div>
                </div>
    }

    renderFloor()
    {
        if (!stringUtil.isStringNullOrEmpty(this.state.criticalError))
        {
            return <div className='h-100 d-flex flex-column justify-content-center'>
                        <ErrorComponent error={this.state.criticalError}/>
                   </div>
        }

        if (this.state.isLoadingSales)
        {
            return <div className='h-100 d-flex flex-column justify-content-center'>
                        <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_sales")}/>
                   </div>
        }

        var mainComponent = <Floor onStencilClick={this.onStencilClick} isStencilEnabled={this.isStencilEnabled} isStencilSelected={this.isStencilSelected}/>
                    

        if (stringUtil.isStringNullOrEmpty(this.state.validationError))
            return mainComponent;

        return <div style={{height:'100%'}}>
                    <div style={{position:'absolute', left:'20px', top:'10px', zIndex:1}}>
                    <ErrorComponent error={this.state.validationError}/>
                    </div>
                    {mainComponent}
                </div>
    }


    onStencilClick(stencil, openSale, mergedSale)
    {
        let sale = openSale ?? mergedSale;

        if (sale != null)
            this.onEngagedStencilClick(stencil, sale);
        else
            this.onNonEngagedStencilClick(stencil);
    }

    onEngagedStencilClick(stencil, sale)
    {
        if (this.state.context.sale == null)
        {
            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
            saleContextUtil.openSale(sale, true);
            return;
        }

        if (!stringUtil.areStringSame(this.state.context.sale.id, sale.id))
            return;

        this.onNonEngagedStencilClick(stencil);
    }

    onNonEngagedStencilClick(stencil)
    {
        if (stringUtil.isStringNullOrEmpty(this.state.context.tableNumber))
        {
            this.state.context.tableNumber = stencil.tableNumber;
            this.setState({});
            return;
        }

        if (stringUtil.areStringSame(stencil.tableNumber, this.state.context.tableNumber))
        {
            this.state.context.tableNumber = null;
            this.state.context.linkedTables = [];
            this.setState({});
            return;
        }

        if (this.state.context.linkedTables.find(t => stringUtil.areStringSame(t, stencil.tableNumber)))
        {
            this.state.context.linkedTables = this.state.context.linkedTables.filter(t => !stringUtil.areStringSame(t, stencil.tableNumber));
            this.setState({});
            return;
        }

        this.state.context.linkedTables.push(stencil.tableNumber);
        this.setState({});
    }

    isStencilEnabled(stencil, openSale, mergedSale)
    {
        let sale = openSale ?? mergedSale;
        if (sale == null || this.state.context.sale == null)
            return true;

        return stringUtil.areStringSame(this.state.context.sale.id, sale.id);
    }

    isStencilSelected(stencil, openSale, mergedSale)
    {
        if (!this.isStencilEnabled(stencil, openSale, mergedSale))
            return false;

        if (stringUtil.areStringSame(this.state.context.tableNumber, stencil.tableNumber))
            return "primary";
        
        if (this.state.context.linkedTables.find(t => stringUtil.areStringSame(t, stencil.tableNumber)) != null)
            return "secondary";

        return null;
    }

    openNewSale()
    {
        let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeDineIn, storefrontUtility.getCurrentStorefront().id);
        let saleContext = saleContextUtil.instantiateSaleContext(sale, false);

        if (!stringUtil.isStringNullOrEmpty(this.state.context.tableNumber))
        {
            sale.tableNumber = this.state.context.tableNumber;
            sale.linkedTables = this.state.context.linkedTables;
            sale.number = `${sale.tableNumber} / ${sale.number}`;
            sale.server = this.state.context.server;
            sale.noOfGuests = this.state.context.noOfGuests;
        }

        if (this.props.onDone != null)
        {
            this.props.onDone();
        }
        else
        {
            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
            saleContextUtil.openSaleContext(saleContext);
        }
    }

    updateExistingSale()
    {
        var originalSaleNumber = this.state.context.sale.number.split("/");
        if (originalSaleNumber.length == 2)
            originalSaleNumber = stringUtil.trimString(originalSaleNumber[1]);
        else
            originalSaleNumber = stringUtil.trimString(originalSaleNumber[0]);

        this.state.context.sale.number = originalSaleNumber;
        if (!stringUtil.isStringNullOrEmpty(this.state.context.tableNumber))
        {
            this.state.context.sale.tableNumber = this.state.context.tableNumber;
            this.state.context.sale.linkedTables = this.state.context.linkedTables;
            this.state.context.sale.server = this.state.context.server;
            this.state.context.sale.noOfGuests = this.state.context.noOfGuests;
            this.state.context.sale.number = `${this.state.context.tableNumber} / ${originalSaleNumber}`;
        }
        saleContextUtil.raiseSaleContextSaleChangeEvent(false);

        if (this.props.onDone != null)
        {
            this.props.onDone();
        }
        else
        {
            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
        }
    }

    async loadSales()
    {
        try
        {
            await salesLoader.loadTodaysSalesAndSalesStatus();
            if (this.state.unmounted) return;
            this.state.isLoadingSales = false;
            this.setState({});
        }
        catch(error)
        {
            logger.error(`Error occurred while loading sales in table selection. ${error}`, {}, error);
            if (this.state.unmounted) return;

            this.state.isLoadingSales = false;
            this.state.criticalError = error;
            this.setState({});
        }
    }

    isDisabled()
    {
        return this.state.isLoadingSales || !stringUtil.isStringNullOrEmpty(this.state.criticalError);
    }

    renderNoOfCoversComponent()
    {
        return <div style={{paddingRight:'3vw', marginRight:'2vw', borderRight:'1px solid var(--colors-neutral)'}}>
                    <table>
                        <tr>
                            <td>
                                <div className='text-muted px-2'>{translator.getLabel("number_of_covers")}</div>
                            </td>
                            <td>
                                <Button className='btn-action' disabled={this.isDisabled()} style={{fontSize:'2rem', minWidth:'5vw', maxWidth:'5vw', minHeight:'5.5vh', maxHeight:'5.5vh'}}
                                        onClick={()=>
                                        {
                                            if (this.state.context.noOfGuests <= 1)
                                                return;

                                                this.state.context.noOfGuests = this.state.context.noOfGuests - 1;
                                            this.state.validationError = null;
                                            this.setState({});
                                        }}><div style={{marginTop:'-5px'}}>-</div></Button>
                            </td>


                            <td>
                                <div className='px-3' style={{ fontSize: "25px", fontWeight: "bold", textAlign: "center", minHeight: "34px"}}>{this.state.context.noOfGuests}</div>
                            </td>
                            <td>
                                <Button className='btn-action' disabled={this.isDisabled()} style={{fontSize:'2rem', minWidth:'5vw', maxWidth:'5vw', minHeight:'5.5vh', maxHeight:'5.5vh'}}
                                        onClick={()=>
                                        {
                                            this.state.context.noOfGuests = this.state.context.noOfGuests + 1;
                                            this.state.validationError = null;
                                            this.setState({});
                                        }}><div style={{marginTop:'-5px'}}>+</div></Button>
                            </td>


                        </tr>
                    </table>
                </div>
    }

    renderServerComponent()
    {
        var options = [];
        let selectedOption = null;

        var allStaffs = staffUtility.getAllActiveStaff();
        allStaffs.forEach(staff =>
            {
                var option = {};
                option.label = <div>
                                    {staffUtility.getStaffCompleteName(staff)}
                                </div>;
                option.value = staffUtility.getStaffCompleteName(staff);

                if (stringUtil.areStringSame(this.state.context.server, option.value))
                    selectedOption = option;

                options.push(option);
            })

        const customStyles = 
        {
            control: (provided, state) => ({
                ...provided,
                minHeight: '6vh',
                height: '6vh',
                width:'max-content',
                minWidth:'20vw',
            }),
            menu: provided => ({ ...provided, zIndex: 9999}),
        };
        
        return <div>
                    <table>
                        <tr>
                            <td>
                                <div className='text-muted' style={{marginRight:'5px'}}>{translator.getLabel("server")}</div>
                            </td>
                            <td>
                                <Select inputProps={{readOnly:true}}
                                    
                                    options={options}
                                    value={selectedOption}
                                    placeholder={translator.getLabel("select_staff")}
                                    isSearchable={false}
                                    isDisabled={this.isDisabled()}
                                    styles={customStyles}
                                    onChange={(selection)=>
                                        {   
                                            if (selection == null)
                                                this.state.context.server = "";
                                            else
                                                this.state.context.server = selection.value;

                                            this.state.validationError = null;
                                            this.setState({});
                                        }}
                                    multi={false}
                                    clearable={false}
                                />
                            </td>
                        </tr>
                    </table>
                    
                </div>
    }
}

export default TableSelectionView